import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MemberData } from 'Models/Common/Health.General'
import { IHealthPincode } from 'Models/ResponseModels/Health'
import uuid from 'react-uuid'

interface IState {
  memberDetails: { [key: string]: MemberData }
  isParentsIncluded: boolean
  proposer: MemberData
  selfPincode: IHealthPincode
  parentsPincode: IHealthPincode
  isProposerIncluded: boolean
  sum_insured: string
}

const initialState: IState = {
  memberDetails: {},
  isParentsIncluded: false,
  isProposerIncluded: false,
  selfPincode: {
    pincode: '',
    area_name: '',
    area_code: '',
    city_code: '',
    city_name: '',
    state_name: '',
    state_code: '',
    from_cache: false,
    is_district: false,
  },
  parentsPincode: {
    pincode: '',
    area_name: '',
    area_code: '',
    city_code: '',
    city_name: '',
    state_name: '',
    state_code: '',
    from_cache: false,
    is_district: false,
  },
  proposer: {
    type: 'adult',
    member_type: 'proposer',
    salutation: '',
    age: '',
    dob: '',
    pincode: '',
    proposer: 1,
    gender: '',
    city_name: '',
    state_name: '',
    nationality: '',
    selected: false,
    code: '',
    marital_status: '',
    member_insured: '',
    firstname: '',
    middlename: '',
    lastname: '',
    relationship_with_proposer: '',
    mobile: '',
    email: '',
    occupation: '',
    bmi: '',
    height: '',
    weight: '',
    educational_qualification: '',
    annual_income: '',
    aadhar_card_number: '',
    pan_number: '',
    current_address: '',
    pincode_map: {
      id: '',
      pincode: '',
      area_name: '',
      city_name: '',
      state_name: '',
    },
    permanent_address: '',
    permanent_address_pincode_map: {
      id: '',
      pincode: '',
      area_name: '',
      city_name: '',
      state_name: '',
    },
    nominee_details: {
      salutation: '',
      firstname: '',
      middlename: '',
      lastname: '',
      dob: '',
      gender: '',
      relationship: '',
      mobile: '',
      occupation: '',
      address: '',
      marital_status: '',
      pincode_map: {
        area_name: '',
        city_name: '',
        id: '',
        pincode: '',
        state_name: '',
      },
    },
    medical_questions: [],
    lifestyle_questions: [],
    selectedQuoteNumber: '',
  },
  sum_insured: '',
}

const checkforParents = (state: IState) => {
  console.log(state.memberDetails, 'heloooo')
  let isParentsIncluded = false
  Object.keys(state.memberDetails).forEach((member) => {
    if (
      state.memberDetails[member].member_type === 'father' ||
      state.memberDetails[member].member_type === 'mother'
    ) {
      isParentsIncluded = true
    }
  })
  return isParentsIncluded
}

const memberDetailsSlice = createSlice({
  name: 'memberDetails',
  initialState: initialState,
  reducers: {
    updateMember: (
      state,
      action: PayloadAction<{
        code: string
        memberDetail: MemberData
      }>,
    ) => {
      if (state.memberDetails[action.payload.code]) {
        state.memberDetails[action.payload.code] = action.payload.memberDetail
      } else {
        state.memberDetails[uuid()] = action.payload.memberDetail
      }
    },
    addMembers: (state, action: PayloadAction<MemberData[]>) => {
      console.log(action.payload)
      action.payload.forEach((member) => {
        console.log(state.memberDetails[member.code!], member.code)
        const code = uuid()
        if (state.memberDetails[member.code!]) {
          state.memberDetails[member.code!] = member
        } else {
          member.code = code
          state.memberDetails[code] = member
        }
      })
      state.isParentsIncluded = checkforParents(state)
    },
    deleteMember: (
      state,
      action: PayloadAction<{
        key: string
      }>,
    ) => {
      delete state.memberDetails[action.payload.key]
    },
    updateProposer: (
      state,
      action: PayloadAction<{
        data: MemberData
        isProposerIncluded: boolean
      }>,
    ) => {
      console.log(action.payload.isProposerIncluded)
      state.proposer = {
        ...state.proposer,
        ...action.payload.data,
      }
      state.isProposerIncluded = action.payload.isProposerIncluded
    },
    updateSumInsured: (state, action: PayloadAction<string>) => {
      state.sum_insured = action.payload
    },
    deleteMembers: (state) => {
      state.memberDetails = {}
      state.isParentsIncluded = false
    },
    updateProposerPincode: (state, action: PayloadAction<IHealthPincode>) => {
      state.selfPincode = action.payload
    },
    updateParentsPincode: (state, action: PayloadAction<IHealthPincode>) => {
      state.parentsPincode = action.payload
    },
  },
})

const { reducer } = memberDetailsSlice

export const {
  addMembers,
  updateProposer,
  updateSumInsured,
  deleteMembers,
  updateMember,
  updateProposerPincode,
  updateParentsPincode,
} = memberDetailsSlice.actions

export { reducer as memberDetailsReducer }
